<template>
  <div class="modal fade" id="cuModal" tabindex="-1" role="dialog" aria-labelledby="cuModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cuModalLabel">{{ modalContent.title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label" for="name">Name</label>
            <input class="form-control" id="name"
              :class="form.errors.has('name') ? 'is-invalid' : ''"
              v-model="form.name" @keydown="form.errors.clear('name')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('name')"
              v-text="form.errors.get('name')"
            />
          </div>
          <div class="form-group">
            <label class="custom-label" for="currency">Currency Code</label>
            <input class="form-control" id="currency"
              :class="form.errors.has('currency') ? 'is-invalid' : ''"
              v-model="form.currency" @keydown="form.errors.clear('currency')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('currency')"
              v-text="form.errors.get('currency')"
            />
          </div>
          <div class="form-group">
            <label class="custom-label" for="vat">VAT</label>
            <div class="input-group">
              <input class="form-control" id="vat"
                :class="form.errors.has('vat') ? 'is-invalid' : ''"
                v-model="form.vat" @keydown="form.errors.clear('vat')"
              >
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
            <div class="invalid-feedback"
              v-if="form.errors.has('vat')"
              v-text="form.errors.get('vat')"
            />
          </div>
          <div class="form-group">
            <label class="custom-label" for="import_duties">Import Duties</label>
            <div class="input-group">
              <input class="form-control" id="import_duties"
                :class="form.errors.has('import_duties') ? 'is-invalid' : ''"
                v-model="form.import_duties" @keydown="form.errors.clear('import_duties')"
              >
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
            <div class="invalid-feedback"
              v-if="form.errors.has('import_duties')"
              v-text="form.errors.get('import_duties')"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary"
            :disabled="form.isWorking()"
            @click="handleSubmit"
          >
            <span v-if="form.isWorking()">Checking Input...</span>
            <span v-else>{{ modalContent.submitText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import createUpdateMixin from './../cu-modal-mixin'

  export default {
    mixins: [createUpdateMixin],
    data() {
      return {
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/countries/CuModal.vue